import { Component, EventEmitter, Input, Output } from '@angular/core';

export type SuggestionColour =
  | 'teal'
  | 'orange'
  | 'green-no-outline'
  | 'red-no-outline'
  | 'grey-no-outline';

const DISMISS_ANIMATION_MS = 400;

@Component({
  selector: 'csi-suggestion',
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.scss']
})
export class SuggestionComponent {
  @Input() colour: SuggestionColour = 'teal';
  @Input() icon: string = '';
  @Input() text: string = '';
  @Input() buttonText: string = 'Apply Changes';

  @Input() set shouldDismiss(val: boolean) {
    if (val && !this.isDismissing) {
      this._startDismiss();
    }
  }

  @Output() actionClicked = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  isDismissing = false;

  onDismissClick() {
    this._startDismiss();
  }

  private _startDismiss() {
    this.isDismissing = true;
    setTimeout(() => this.dismissed.emit(), DISMISS_ANIMATION_MS);
  }
}
